module.exports = __webpack_public_path__ + "img/qrlogo.a8fe1294.jpg";